/* ============================================================================
   CONSULTA DE INVENTARIO — Portal Kennedy
   ---------------------------------------------------------------------------
   Todo el inventario en una pantalla: cuanto hay, cuanto esta reservado y por
   quien, cuanto viene en camino y cuando llega.

   POR QUE USA EL RPC `inv_buscar` Y NO `vista_inventario`
   -------------------------------------------------------
   La vista NO tiene la columna `grupo` (se comprueba en invEnrich: el portal
   le pide itemcode, itemname, foto_url, peso, volumen, unidadesbulto, subg,
   caracteristicas, marca, precioventa, disponible..., y para los grupos va
   siempre a la TABLA `inventario`). Al filtrar la vista por `grupo` PostgREST
   respondia 400, q() se tragaba el error y la pantalla salia vacia: ese era el
   motivo de que ningun departamento devolviera nada. Tampoco tiene `frgnname`,
   asi que la busqueda tambien fallaba en silencio.

   `inv_buscar` es el mismo RPC que usan Inventario y Catalogo. Filtra por
   grupos, bultos minimos, stock, precio y texto en el servidor, pagina, y
   devuelve `picturname` para las fotos.

   Se apoya en lo que ya existe:
     lineFoto(picturname, foto_url)  miniatura + zoom al pasar el mouse + clic
     verSeparadoVentas(sku)          quien tiene la mercancia separada
     verItem(sku)                    ficha del articulo
     npAgregar(linea)                carrito del pedido en curso
     xlsxExport(...)                 Excel del resto de reportes

   Prefijo `cinv`.
============================================================================ */

// ── Estado ──────────────────────────────────────────────────────────────────
var CINV_ROWS=[], CINV_OFF=0, CINV_FIN=false, CINV_CARGANDO=false;
var CINV_TANDA=60;
var CINV_Q='', CINV_TIMER=null;
var CINV_ORDEN='reciente';        // clave de CINV_ORDENES
var CINV_DEPT='todos';
var CINV_MARCA='';
var CINV_CHIP='todos';
var CINV_MIN={exist:'', disp:'', bultos:'', pmin:'', pmax:''};
var CINV_SEL={};
var CINV_LLEG={};                 // itemcode -> fechas de llegada
var CINV_MARCAS=[];
var CINV_MASFIL=false;

// Tope de filas que se traen cuando el orden hay que hacerlo aqui.
var CINV_LOCAL_TOPE=1500;
// Atajos al orden activo.
function cinvOrdDef(){ return CINV_ORDENES[CINV_ORDEN]||CINV_ORDENES.reciente; }
function cinvEsLocal(){ return !!cinvOrdDef().local; }

// Un solo desplegable de orden. Los que el RPC sabe hacer van al servidor
// (`rpc`); los demas se ordenan aqui sobre un bloque grande (`local`).
var CINV_ORDENES={
  'reciente'   :{t:'Entrada  m\u00e1s reciente', rpc:'reciente'},
  'sku'        :{t:'SKU  A \u2192 Z',            rpc:'sku'},
  'nombre'     :{t:'Descripci\u00f3n  A \u2192 Z', rpc:'nombre'},
  'stock_desc' :{t:'Existencia  mayor primero', rpc:'stock_desc'},
  'stock_asc'  :{t:'Existencia  menor primero', rpc:'stock_asc'},
  'precio_desc':{t:'Precio  mayor primero',     rpc:'precio_desc'},
  'precio_asc' :{t:'Precio  menor primero',     rpc:'precio_asc'},
  'res_desc'   :{t:'Reservado  mayor primero',  local:'iscommited',    desc:true },
  'disp_desc'  :{t:'Disponible  mayor primero', local:'disponible',    desc:true },
  'disp_asc'   :{t:'Disponible  menor primero', local:'disponible',    desc:false},
  'bult_desc'  :{t:'Bultos disp.  mayor primero', local:'bultos',      desc:true },
  'lleg_desc'  :{t:'Por llegar  mayor primero', local:'onorder',       desc:true },
  'llega_asc'  :{t:'Lo que llega antes',        local:'prox_llegada',  desc:false},
  'hist_desc'  :{t:'Hist. comprado  mayor primero', local:'hist_comprado', desc:true },
  'ultc_desc'  :{t:'\u00dalt. compra  mayor primero', local:'u_cant_ult_ent', desc:true },
  'marg_desc'  :{t:'Margen  mayor primero',     local:'margen',        desc:true },
  'marg_asc'   :{t:'Margen  menor primero',     local:'margen',        desc:false},
  // El RPC solo ordena en un sentido por campo; el contrario se hace aqui,
  // para que cada cabecera pueda alternar de mayor a menor y al reves.
  'sku_z'      :{t:'SKU  Z \u2192 A',            local:'itemcode',      desc:true },
  'nombre_z'   :{t:'Descripci\u00f3n  Z \u2192 A', local:'itemname',   desc:true },
  'entrada_v'  :{t:'Entrada  m\u00e1s antigua',  local:'fechaentrada',  desc:false},
  'res_asc'    :{t:'Reservado  menor primero',  local:'iscommited',    desc:false},
  'lleg_asc'   :{t:'Por llegar  menor primero', local:'onorder',       desc:false},
  'bult_asc'   :{t:'Bultos disp.  menor primero', local:'bultos',      desc:false},
  'ultc_asc'   :{t:'\u00dalt. compra  menor primero', local:'u_cant_ult_ent', desc:false},
  'hist_asc'   :{t:'Hist. comprado  menor primero', local:'hist_comprado', desc:false},
  'llega_desc' :{t:'Lo que llega m\u00e1s tarde', local:'prox_llegada', desc:true }
};

// Que orden corresponde a cada columna: [ascendente, descendente].
var CINV_COL_ORD={
  sku    :['sku','sku_z'],
  desc   :['nombre','nombre_z'],
  stock  :['stock_asc','stock_desc'],
  sep    :['res_asc','res_desc'],
  disp   :['disp_asc','disp_desc'],
  lleg   :['lleg_asc','lleg_desc'],
  bulto  :['bult_asc','bult_desc'],
  ultc   :['ultc_asc','ultc_desc'],
  hist   :['hist_asc','hist_desc'],
  entrada:['entrada_v','reciente'],
  precio :['precio_asc','precio_desc'],
  margen :['marg_asc','marg_desc']
};
// Las columnas de texto empiezan de la A a la Z; las de numeros, de mayor a
// menor, que es lo que se suele querer ver primero.
var CINV_COL_TXT={sku:1, desc:1};

// Departamentos: solo estos, como pediste. Cada uno se traduce a los nombres
// REALES de grupo de SAP que contengan alguna de sus palabras; los que no
// encuentren ningun grupo no se pintan, asi cualquier chip visible devuelve
// resultados si o si.
var CINV_DEPT_DEF=[
  {k:'hogar',      l:'Hogar',            pal:['hogar']},
  {k:'muebles',    l:'Muebles',          pal:['mueble']},
  {k:'alfombras',  l:'Alfombras',        pal:['alfombra','alfombr']},
  {k:'ropa',       l:'Ropa',             pal:['ropa']},
  {k:'deco',       l:'Home Deco',        pal:['deco']},
  {k:'campamento', l:'Campamento',       pal:['campamento','camping']},
  {k:'electronica',l:'Electr\u00f3nica', pal:['electr']}
];
var CINV_GRUPOS_REALES=[];    // todos los grupos de la base
var CINV_DEPTS=[];            // los de arriba que si tienen grupos
var CINV_DEPTS_CARGADOS=false;

var CINV_CHIPS=[
  {k:'todos',     t:'Todos'},
  {k:'stock',     t:'Con existencia'},
  {k:'reservado', t:'Con reservado'},
  {k:'llegar',    t:'Por llegar'},
  {k:'agotado',   t:'Agotados'},
  {k:'negativo',  t:'Sobrevendidos'}
];


// ── Utilidades ──────────────────────────────────────────────────────────────
function cinvEsc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function cinvNum(v){ var n=Number(v); return isFinite(n)?n:0; }
function cinvN(v){ return cinvNum(v).toLocaleString('en-US'); }
function cinvMon(v){ return '$'+cinvNum(v).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }

function cinvDisp(x){
  if(x.disponible!=null && x.disponible!=='') return cinvNum(x.disponible);
  return cinvNum(x.onhand)-cinvNum(x.iscommited);
}
function cinvPack(x){ return Math.max(1, cinvNum(x.unidadesbulto)||cinvNum(x.salpackun)||1); }
function cinvBultos(x){ return Math.floor(cinvDisp(x)/cinvPack(x)); }

function cinvLlegada(x){
  var d=(x.prox_llegada||x.ultima_llegada||'');
  if(!d && CINV_LLEG[x.itemcode]) d=CINV_LLEG[x.itemcode].prox_llegada||'';
  return String(d||'').slice(0,10);
}
function cinvOrdenes(x){
  if(x.ordenes_abiertas!=null) return cinvNum(x.ordenes_abiertas);
  var r=CINV_LLEG[x.itemcode];
  return r?cinvNum(r.ordenes_abiertas):0;
}

// Dias que faltan. La fecha se parte a mano: Safari lee "2026-09-10" como UTC
// y en Panama eso corre un dia.
function cinvDias(fecha){
  var p=String(fecha||'').slice(0,10).split('-');
  if(p.length!==3) return null;
  var d=new Date(+p[0], +p[1]-1, +p[2]);
  if(isNaN(d.getTime())) return null;
  var hoy=new Date(); hoy.setHours(0,0,0,0);
  return Math.round((d.getTime()-hoy.getTime())/86400000);
}
function cinvFechaCorta(f){
  var p=String(f||'').slice(0,10).split('-');
  return p.length===3 ? (p[2]+'/'+p[1]+'/'+p[0].slice(2)) : '';
}
function cinvLlegadaTxt(x){
  var f=cinvLlegada(x);
  if(!f) return cinvNum(x.onorder)>0 ? '<span class="cinv-dim">sin fecha</span>' : '';
  var d=cinvDias(f), cls='cinv-dim', extra='';
  if(d!=null){
    if(d<0){        cls='cinv-rojo';  extra=' \u00b7 vencida'; }
    else if(d===0){ cls='cinv-verde'; extra=' \u00b7 hoy'; }
    else if(d<=15){ cls='cinv-verde'; extra=' \u00b7 '+d+'d'; }
    else if(d<=45){ cls='cinv-ambar'; extra=' \u00b7 '+d+'d'; }
  }
  return '<span class="'+cls+'">'+cinvFechaCorta(f)
    +'<span class="cinv-dim">'+extra+'</span></span>';
}


/* ══════════════════════════════════════════════════════════════════════════
   ESTILOS
   ══════════════════════════════════════════════════════════════════════════ */
function cinvCSS(){
  if(document.getElementById('cinv-css')) return;
  var st=document.createElement('style');
  st.id='cinv-css';
  st.textContent=[
  '.cinv-wrap{border:1px solid var(--border);border-radius:var(--r,12px);background:var(--surface)}',
  // `position:sticky` se ancla al ancestro que hace scroll. Con overflow-x
  // el contenedor YA era ese ancestro, pero como no se desplazaba en vertical
  // la cabecera se iba con la pagina. Ahora el listado tiene su propio alto y
  // scroll en los dos ejes: la cabecera se queda fija de verdad.
  '.cinv-scroll{overflow:auto;-webkit-overflow-scrolling:touch}',
  // Rejilla: cabecera y filas comparten la misma plantilla de columnas, que
  // se pone inline porque depende de si el usuario ve el margen o no.
  '.cinv-g{display:grid;gap:0 10px;align-items:center;padding:6px 12px}',
  '.cinv-g>div{min-width:0;overflow:hidden}',
  '.cinv-g>div.n{text-align:right}',
  '.cinv-hd{position:sticky;top:0;z-index:3;background:var(--surface2,#F3F4F6);',
     'border-bottom:1px solid var(--border);font-size:10px;font-weight:700;',
     'text-transform:uppercase;letter-spacing:.045em;color:var(--text3);padding-top:9px;',
     'padding-bottom:9px;white-space:nowrap;text-overflow:ellipsis}',
  '.cinv-row{border-bottom:1px solid var(--border);font-size:12.5px}',
  '.cinv-row:nth-child(even){background:rgba(127,127,127,.035)}',
  '.cinv-row:hover{background:rgba(79,140,255,.08)}',
  '.cinv-row.sel{background:rgba(79,140,255,.15)}',
  '.cinv-desc{font-size:12.5px;line-height:1.25;overflow:hidden;text-overflow:ellipsis;',
     'white-space:nowrap}',
  '.cinv-sub{color:var(--text3);font-size:10.5px;font-weight:400;line-height:1.25;',
     'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
  '.cinv-lila{color:#7C3AED}',
  '.cinv-th{cursor:pointer;user-select:none;white-space:nowrap}',
  '.cinv-th:hover{text-decoration:underline}',
  '.cinv-fl{opacity:.35;font-size:11px}',
  '.cinv-th:hover .cinv-fl{opacity:.9}',
  '.cinv-fa{font-size:9px}',
  '.cinv-sku{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:11.5px;',
     'color:var(--blue2);cursor:pointer;text-decoration:underline;text-underline-offset:2px}',
  '.cinv-rojo{color:#DC2626;font-weight:700}',
  '.cinv-verde{color:#15803D;font-weight:700}',
  '.cinv-ambar{color:#B45309;font-weight:700}',
  '.cinv-dim{color:var(--text3);font-weight:400}',
  '.cinv-lnk{cursor:pointer;text-decoration:underline;text-underline-offset:2px}',
  '.cinv-chip{cursor:pointer;font-size:11.5px;font-weight:600;padding:5px 12px;border-radius:14px;',
     'border:1px solid var(--border);background:var(--surface);color:var(--text2);white-space:nowrap}',
  '.cinv-chip.on{border-color:var(--blue);background:var(--blue);color:#fff}',
  '.cinv-mini{width:78px;padding:5px 7px;border:1px solid var(--border);border-radius:7px;',
     'background:var(--surface);color:var(--text);font-size:12px;font-family:inherit}',
  '#cinv-selbar{position:sticky;bottom:0;z-index:6;display:none;align-items:center;gap:10px;',
     'flex-wrap:wrap;padding:10px 14px;background:var(--surface);border-top:1px solid var(--border);',
     'border-radius:0 0 var(--r,12px) var(--r,12px);box-shadow:0 -6px 20px rgba(0,0,0,.08)}'
  ].join('');
  document.head.appendChild(st);
}


/* ══════════════════════════════════════════════════════════════════════════
   LA PANTALLA
   ══════════════════════════════════════════════════════════════════════════ */

// ── Permisos ────────────────────────────────────────────────────────────
// La pantalla es solo para administradores y vendedores. Los clientes no
// entran (el menú ya se les oculta en clienteLockdown, pero se comprueba
// también aquí por si llegan por el historial del navegador).
function cinvRol(){
  try{ return String((typeof CU!=='undefined'&&CU&&CU.rol)||'').toLowerCase(); }
  catch(e){ return ''; }
}
function cinvUsuario(){
  try{ return String((CU&&(CU.username||String(CU.email||'').split('@')[0]))||'').toLowerCase(); }
  catch(e){ return ''; }
}
function cinvEsAdmin(){ return ['admin','administrador','gerencia'].indexOf(cinvRol())>=0; }
function cinvPuedeVer(){ return cinvEsAdmin() || cinvRol()==='vendedor'; }

// El margen solo lo ven los administradores, Gady y Henry: es informacion de
// costos y no tiene que estar delante de todo el equipo de ventas.
var CINV_MARGEN_USUARIOS=['gady','henry'];
function cinvVerMargen(){
  return cinvEsAdmin() || CINV_MARGEN_USUARIOS.indexOf(cinvUsuario())>=0;
}

// ── Volver del detalle sin perder el sitio ──────────────────────────────
// go() no borra el HTML de la pagina, solo le quita la clase `active`: el
// listado sigue montado. Lo que lo destruia era este mismo cinvInit, que al
// volver del detalle repintaba todo desde la primera tanda.
//
// El boton Volver del portal llama a lo que haya en VISTA_ACTUAL, asi que
// antes de abrir la ficha se pone ahi una funcion propia y se apunta hasta
// donde estaba desplazado el listado.
var CINV_VOLVIENDO=false, CINV_SCROLL=0;

function cinvVerItem(sku){
  var sc=document.getElementById('cinv-scroll');
  CINV_SCROLL = sc ? sc.scrollTop : 0;
  try{ VISTA_ACTUAL=function(){ cinvVolver(); }; }catch(e){}
  try{ verItem(sku); }catch(e){}
}

function cinvVolver(){
  CINV_VOLVIENDO=true;
  try{ go('cinv', document.getElementById('nav-cinv')); }catch(e){}
  // go() dispara cinvInit a los 50 ms; alli se restaura el listado.
}

function cinvInit(){
  var c0=document.getElementById('cinv-content');

  if(CINV_VOLVIENDO){
    CINV_VOLVIENDO=false;
    var body=document.getElementById('cinv-body');
    if(CINV_ROWS.length && body && body.innerHTML){
      // Todo sigue pintado: basta con recolocar el alto, volver a enganchar el
      // observador (el contenedor pudo cambiar de tamaño) y devolver el scroll.
      cinvAltura();
      cinvObservar();
      var sc=document.getElementById('cinv-scroll');
      if(sc){
        // En el mismo cuadro no funciona: el contenedor acaba de volverse
        // visible y todavia no tiene alto, asi que scrollTop se queda en 0.
        var poner=function(){ sc.scrollTop=CINV_SCROLL; };
        if(typeof requestAnimationFrame==='function') requestAnimationFrame(poner);
        setTimeout(poner, 60);
      }
      return;
    }
  }

  if(!cinvPuedeVer()){
    if(c0) c0.innerHTML='<div class="card" style="text-align:center;padding:30px;color:var(--text3)">'
      +'Esta pantalla est\u00e1 disponible solo para administradores y vendedores.</div>';
    return;
  }
  cinvCSS();
  cinvRender();
}

function cinvRender(){
  var box=document.getElementById('cinv-content'); if(!box) return;
  cinvCSS();

  var opts=Object.keys(CINV_ORDENES).map(function(k){
    return '<option value="'+k+'"'+((CINV_ORDEN===k)?' selected':'')+'>'
      +CINV_ORDENES[k].t+'</option>';
  }).join('');

  var h='';
  h+='<div style="font-size:12.5px;color:var(--text3);margin-bottom:10px">'
    +'Pasa el mouse por la foto para verla grande (o pulsa para ampliar). '
    +'<b class="cinv-rojo">Sep</b> dice qui\u00e9n lo tiene separado; '
    +'<b class="cinv-ambar">Por lleg</b>, en qu\u00e9 orden viene.</div>';
  h+='<div id="cinv-aviso"></div>';

  h+='<div class="card" style="margin-bottom:12px">';
  h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">';
  h+='<input id="cinv-q" class="inp" value="'+cinvEsc(CINV_Q)+'" oninput="cinvBuscar(this.value)" '
    +'placeholder="SKU, descripci\u00f3n o c\u00f3digo de barras" style="flex:1;min-width:200px">';
  h+='<select id="cinv-marca" class="inp" onchange="cinvSetMarca(this.value)" style="max-width:180px">'
    +'<option value="">Todas las marcas</option>'
    +CINV_MARCAS.map(function(m){
        return '<option value="'+cinvEsc(m)+'"'+(CINV_MARCA===m?' selected':'')+'>'+cinvEsc(m)+'</option>';
      }).join('')+'</select>';
  h+='<span style="font-size:11.5px;color:var(--text3)">Ordenar</span>';
  h+='<select id="cinv-orden" class="inp" onchange="cinvSetOrden(this.value)" style="max-width:230px">'
    +opts+'</select>';
  h+='<button class="btn btn-sm" onclick="cinvSetOrden(\'reciente\')" '
    +(CINV_ORDEN==='reciente'?'style="border-color:var(--blue);color:var(--blue2)" ':'')
    +'title="Volver a lo m\u00e1s nuevo primero">\u21bb M\u00e1s reciente</button>';
  h+='<button class="btn btn-sm" onclick="cinvMasFiltros()">'+(CINV_MASFIL?'\u25b4':'\u25be')+' Filtros</button>';
  h+='<button class="btn btn-sm" id="cinv-xlsx" onclick="cinvExcel()">\ud83d\udcca Excel</button>';
  h+='<span id="cinv-cnt" style="font-size:11.5px;color:var(--text3);white-space:nowrap"></span>';
  h+='</div>';

  h+='<div id="cinv-depts" style="display:flex;gap:5px;flex-wrap:wrap;margin-top:10px">'
    +cinvChipsDept()+'</div>';

  h+='<div style="display:flex;gap:5px;flex-wrap:wrap;margin-top:7px">';
  CINV_CHIPS.forEach(function(c){
    h+='<span class="cinv-chip'+(CINV_CHIP===c.k?' on':'')+'" onclick="cinvSetChip(\''+c.k+'\')">'
      +c.t+'</span>';
  });
  h+='</div>';

  if(CINV_MASFIL){
    h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-top:12px;padding-top:11px;'
      +'border-top:1px solid var(--border)">';
    [['exist','Existencia m\u00edn.'],['disp','Disponible m\u00edn.'],['bultos','Bultos m\u00edn.'],
     ['pmin','Precio m\u00edn.'],['pmax','Precio m\u00e1x.']].forEach(function(f){
      h+='<span style="display:inline-block">'
        +'<span style="display:block;font-size:10px;color:var(--text3);text-transform:uppercase;'
        +'letter-spacing:.04em;font-weight:700;margin-bottom:3px">'+f[1]+'</span>'
        +'<input class="cinv-mini" type="number" min="0" id="cinv-f-'+f[0]+'" '
        +'value="'+cinvEsc(CINV_MIN[f[0]])+'" placeholder="\u2014" '
        +'onchange="cinvSetMin(\''+f[0]+'\',this.value)"></span>';
    });
    h+='<span style="display:flex;align-items:flex-end">'
      +'<button class="btn btn-sm" onclick="cinvLimpiar()">Limpiar filtros</button></span>';
    h+='</div>';
  }
  h+='</div>';

  h+='<div class="cinv-wrap"><div class="cinv-scroll" id="cinv-scroll">';
  h+='<div style="min-width:'+cinvAncho()+'px">';
  h+=cinvCabecera();
  h+='<div id="cinv-body"></div>';
  h+='<div id="cinv-mas" style="padding:14px;text-align:center;font-size:12px;'
    +'color:var(--text3)"></div>';
  h+='</div></div>';
  h+='<div id="cinv-selbar"></div>';
  h+='</div>';

  box.innerHTML=h;

  if(!CINV_DEPTS_CARGADOS) cinvCargarDepts();
  if(!CINV_MARCAS.length)  cinvCargarMarcas();

  CINV_ROWS=[]; CINV_OFF=0; CINV_FIN=false;
  cinvCargarMas();
  cinvPintarSelbar();

  cinvAltura();
  cinvObservar();
}

function cinvRecargar(){
  CINV_ROWS=[]; CINV_OFF=0; CINV_FIN=false;
  var b=document.getElementById('cinv-body'); if(b) b.innerHTML='';
  // La cabecera se repinta para mover la flecha a la columna activa.
  var th=document.getElementById('cinv-thead');
  if(th) th.outerHTML=cinvCabecera();
  var chk=document.getElementById('cinv-all'); if(chk) chk.checked=false;
  var sel=document.getElementById('cinv-orden'); if(sel) sel.value=CINV_ORDEN;
  cinvCargarMas();
}

function cinvBuscar(v){
  CINV_Q=v;
  clearTimeout(CINV_TIMER);
  CINV_TIMER=setTimeout(cinvRecargar, 350);
}
function cinvSetDept(k){
  CINV_DEPT=k;
  var box=document.getElementById('cinv-depts');
  if(box) box.innerHTML=cinvChipsDept();
  cinvRecargar();
}
function cinvSetChip(k){ CINV_CHIP=k; cinvRender(); }
function cinvSetMarca(v){ CINV_MARCA=v; cinvRecargar(); }
function cinvSetOrden(v){ if(!v||!CINV_ORDENES[v]) return; CINV_ORDEN=v; cinvRecargar(); }
function cinvMasFiltros(){ CINV_MASFIL=!CINV_MASFIL; cinvRender(); }
function cinvSetMin(k,v){ CINV_MIN[k]=String(v||'').trim(); cinvRecargar(); }
function cinvLimpiar(){
  CINV_MIN={exist:'',disp:'',bultos:'',pmin:'',pmax:''};
  CINV_Q=''; CINV_MARCA=''; CINV_DEPT='todos'; CINV_CHIP='todos';
  cinvRender();
}


/* ── Departamentos ───────────────────────────────────────────────────────── */

function cinvChipsDept(){
  if(!CINV_DEPTS_CARGADOS){
    return '<span style="font-size:11.5px;color:var(--text3)">Cargando departamentos\u2026</span>';
  }
  var h='<span class="cinv-chip'+(CINV_DEPT==='todos'?' on':'')
    +'" onclick="cinvSetDept(\'todos\')">Todos</span>';
  CINV_DEPTS.forEach(function(d){
    h+='<span class="cinv-chip'+(CINV_DEPT===d.k?' on':'')+'" onclick="cinvSetDept(\''+d.k+'\')" '
      +'title="'+cinvEsc(d.grupos.join(', '))+'">'+cinvEsc(d.l)+'</span>';
  });
  return h;
}

function cinvDeptGrupos(k){
  var d=CINV_DEPTS.filter(function(x){ return x.k===k; })[0];
  return d?d.grupos:[];
}

// Los nombres reales de los grupos salen de `grupos_inventario` (la tabla
// canonica) o, si no esta, de los distintos de `inventario`. NUNCA de
// `vista_inventario`: esa vista no tiene la columna `grupo`.
async function cinvCargarDepts(){
  if(CINV_DEPTS_CARGADOS) return;
  var g=[];
  try{
    var r=await q('grupos_inventario','select=grupo&order=grupo');
    g=(r||[]).map(function(x){ return x.grupo; }).filter(Boolean);
  }catch(e){}
  if(!g.length){
    try{
      var rs=await q('inventario','select=grupo&grupo=not.is.null&limit=8000');
      var v={}; (rs||[]).forEach(function(x){ if(x.grupo) v[x.grupo]=1; });
      g=Object.keys(v).sort();
    }catch(e){}
  }
  CINV_GRUPOS_REALES=g;

  // Cada departamento se queda con los grupos reales que lo mencionan. Los que
  // no encuentren ninguno no se pintan: asi ningun chip sale vacio.
  CINV_DEPTS=CINV_DEPT_DEF.map(function(d){
    var gr=g.filter(function(nom){
      var s=String(nom).toLowerCase();
      return d.pal.some(function(p){ return s.indexOf(p)>=0; });
    });
    return {k:d.k, l:d.l, grupos:gr};
  }).filter(function(d){ return d.grupos.length>0; });

  CINV_DEPTS_CARGADOS=true;
  var box=document.getElementById('cinv-depts');
  if(box) box.innerHTML=cinvChipsDept();
}

async function cinvCargarMarcas(){
  try{
    var r=await q('vista_inventario','select=marca&limit=8000');
    var v={}, l=[];
    (r||[]).forEach(function(x){
      var m=String(x.marca||'').trim();
      if(m && !v[m]){ v[m]=1; l.push(m); }
    });
    l.sort(function(a,b){ return a.localeCompare(b); });
    CINV_MARCAS=l;
    var sel=document.getElementById('cinv-marca');
    if(sel){
      sel.innerHTML='<option value="">Todas las marcas</option>'
        +l.map(function(m){
            return '<option value="'+cinvEsc(m)+'"'+(CINV_MARCA===m?' selected':'')+'>'+cinvEsc(m)+'</option>';
          }).join('');
    }
  }catch(e){}
}


/* ══════════════════════════════════════════════════════════════════════════
   CARGA  —  RPC inv_buscar
   ══════════════════════════════════════════════════════════════════════════ */

// La marca -> lista de itemcodes. El RPC no tiene parametro de marca; el
// portal lo resuelve asi mismo (invMarcaCodes) y se cachea porque la lista no
// cambia dentro de la sesion.
var CINV_MARCA_CACHE={};
async function cinvMarcaCodes(m){
  if(!m) return null;
  if(CINV_MARCA_CACHE[m]) return CINV_MARCA_CACHE[m];
  var codes=[], vistos={};
  try{
    var rows=await q('inventario','select=itemcode&marca=eq.'+encodeURIComponent(m)+'&limit=8000');
    (rows||[]).forEach(function(r){
      if(r.itemcode && !vistos[r.itemcode]){ vistos[r.itemcode]=1; codes.push(r.itemcode); }
    });
  }catch(e){}
  // Si la marca no devuelve nada se manda un codigo imposible: mejor una lista
  // vacia que ignorar el filtro y mostrar todo el inventario.
  if(!codes.length) codes=['__ninguno__'];
  CINV_MARCA_CACHE[m]=codes;
  return codes;
}

// El cuerpo que entiende el RPC. Solo se mandan los filtros con valor: los
// null se ignoran del lado del servidor.
async function cinvBody(limit, offset){
  var n=function(v){ return (v!=='' && !isNaN(+v)) ? +v : null; };
  var grupos = (CINV_DEPT!=='todos') ? cinvDeptGrupos(CINV_DEPT) : null;
  var disp=null;
  if(CINV_CHIP==='agotado') disp='agotado';

  return {
    p_itemcodes: await cinvMarcaCodes(CINV_MARCA),
    p_grupos : (grupos && grupos.length) ? grupos : null,
    p_q      : (CINV_Q && CINV_Q.trim()) ? CINV_Q.trim() : null,
    p_pmin   : n(CINV_MIN.pmin),
    p_pmax   : n(CINV_MIN.pmax),
    p_smin   : n(CINV_MIN.exist),
    p_bmin   : (CINV_MIN.bultos!=='' && +CINV_MIN.bultos>0) ? +CINV_MIN.bultos : null,
    p_disp   : disp,
    p_orden  : cinvEsLocal() ? 'reciente' : (cinvOrdDef().rpc||'reciente'),
    p_limit  : limit,
    p_offset : offset
  };
}

async function cinvRpc(body){
  var r=await fetch(SB+'/rest/v1/rpc/inv_buscar',{
    method:'POST',
    headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},
    body:JSON.stringify(body)
  });
  var txt=await r.text();
  if(!r.ok) throw new Error('HTTP '+r.status+': '+txt.slice(0,200));
  try{ return JSON.parse(txt)||[]; }catch(e){ return []; }
}

// El RPC no siempre trae todos los numeros ni la foto: se completan desde la
// vista, que si los tiene, con una sola consulta por tanda.
async function cinvCompletar(filas){
  if(!filas.length) return filas;
  var codes=filas.map(function(x){ return x.itemcode; }).filter(Boolean);
  var map={};
  try{
    var en=codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    var rows=await q('vista_inventario',
      'select=itemcode,itemname,foto_url,picturname,marca,unidadesbulto,precioventa,'
      +'onhand,iscommited,onorder,disponible,codebars,fechaentrada'
      +'&itemcode=in.('+en+')&limit='+codes.length);
    (rows||[]).forEach(function(r){ map[r.itemcode]=r; });
  }catch(e){}

  return filas.map(function(it){
    var v=map[it.itemcode]||{};
    // Lo del RPC manda; la vista rellena lo que falte.
    ['itemname','foto_url','picturname','marca','unidadesbulto','precioventa',
     'onhand','iscommited','onorder','disponible','codebars','fechaentrada'].forEach(function(k){
      if(it[k]==null || it[k]==='') it[k]=v[k];
    });
    return it;
  });
}

// Datos que NO estan en `vista_inventario` y hay que traer de la tabla
// `inventario`: las fechas de llegada, la ultima entrada, el historico
// comprado y los costos. Se piden por tanda y se cachean por SKU.
// Estos datos NO estan en `vista_inventario`: hay que traerlos de la tabla
// `inventario`. Si alguna columna no existe en esta instalacion PostgREST
// devuelve 400 y q() entrega [] sin decir nada, asi que antes se probaba el
// select entero y al primer fallo se perdian TODAS: por eso "Ult. compra" e
// "Hist. comprado" salian en blanco aunque el resto si estuviera. Ahora se
// prueba columna por columna y se usa el subconjunto que exista.
var CINV_EXTRA_BASE='itemcode,prox_llegada,ultima_llegada,ordenes_abiertas';
var CINV_EXTRA_OPC=['u_cant_ult_ent','u_nentrada','hist_comprado','avgprice','lastpurprc'];
var CINV_EXTRA_SEL=null;      // el select que funciona en esta base
var CINV_EXTRA_FALTAN=[];     // las columnas que no existen

async function cinvProbarColumnas(){
  if(CINV_EXTRA_SEL) return CINV_EXTRA_SEL;
  var ok=[], faltan=[];
  // Una consulta de una fila por columna: barata y definitiva.
  for(var i=0;i<CINV_EXTRA_OPC.length;i++){
    var c=CINV_EXTRA_OPC[i], r=null;
    try{ r=await q('inventario','select=itemcode,'+c+'&limit=1'); }catch(e){ r=null; }
    if(r && r.length && Object.prototype.hasOwnProperty.call(r[0], c)) ok.push(c);
    else faltan.push(c);
  }
  CINV_EXTRA_FALTAN=faltan;
  CINV_EXTRA_SEL=CINV_EXTRA_BASE+(ok.length?(','+ok.join(',')):'');
  if(faltan.length) console.warn('[consulta] la tabla inventario no tiene: '+faltan.join(', '));
  return CINV_EXTRA_SEL;
}

async function cinvExtras(filas){
  var faltan=filas.map(function(x){ return x.itemcode; })
    .filter(function(c){ return c && CINV_LLEG[c]===undefined; });
  if(!faltan.length) return;

  var sel=await cinvProbarColumnas();
  var en=faltan.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
  var r=[];
  try{ r=await q('inventario','select='+sel+'&itemcode=in.('+en+')&limit=2000') || []; }
  catch(e){ r=[]; }

  // `inventario` puede traer una fila por bodega: se queda la primera de cada
  // articulo, que es la que tiene los datos de cabecera.
  (r||[]).forEach(function(x){ if(CINV_LLEG[x.itemcode]==null) CINV_LLEG[x.itemcode]=x; });
  faltan.forEach(function(c){ if(CINV_LLEG[c]===undefined) CINV_LLEG[c]=null; });

  await cinvMargenes(faltan);
}

// ── Margen historico ──────────────────────────────────────────────────────
// Sale de `margen_items`, que es lo que SAP muestra en el Sales Analysis: las
// ventas reales del articulo, no el precio de lista contra el ultimo costo.
// Si esa tabla no existe se estima con (precio - costo) / precio y se marca
// con "~" para que se note que es una estimacion, no una venta real.
var CINV_MARGEN={};
var CINV_MARGEN_TABLA=null;   // null sin probar, false no existe

async function cinvMargenes(codes){
  if(CINV_MARGEN_TABLA===false) return;
  var faltan=codes.filter(function(c){ return CINV_MARGEN[c]===undefined; });
  if(!faltan.length) return;
  try{
    var en=faltan.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
    var r=await q('margen_items','select=itemcode,margen_pct,ventas,unidades'
      +'&itemcode=in.('+en+')&limit=2000');
    if(r && r.length) CINV_MARGEN_TABLA=true;
    else if(CINV_MARGEN_TABLA===null) CINV_MARGEN_TABLA=false;
    (r||[]).forEach(function(m){ CINV_MARGEN[m.itemcode]=m; });
  }catch(e){ CINV_MARGEN_TABLA=false; }
  faltan.forEach(function(c){ if(CINV_MARGEN[c]===undefined) CINV_MARGEN[c]=null; });
}

// Devuelve {pct, real}. real=true si viene de ventas; false si es estimado.
function cinvMargen(x){
  var m=CINV_MARGEN[x.itemcode];
  if(m && m.margen_pct!=null) return {pct:cinvNum(m.margen_pct), real:true};
  var e=CINV_LLEG[x.itemcode]||{};
  var pv=cinvNum(x.precioventa);
  var costo=cinvNum(e.avgprice)||cinvNum(x.avgprice)
           ||cinvNum(e.lastpurprc)||cinvNum(x.lastpurprc);
  if(!(pv>0) || !(costo>0)) return null;
  return {pct:(pv-costo)/pv*100, real:false};
}
function cinvMargenTxt(x){
  var m=cinvMargen(x);
  // El portal de compras muestra "—" cuando el articulo no registra ventas, y
  // no una estimacion: un margen inventado en una pantalla de consulta se
  // acaba tomando por bueno. La estimacion queda en el tooltip.
  if(!m || !m.real){
    var t='Este art\u00edculo todav\u00eda no registra ventas, as\u00ed que no hay margen '
      +'hist\u00f3rico que calcular.';
    if(m) t+=' Estimado con el costo y el precio de lista: '+m.pct.toFixed(1)+'%.';
    return '<span class="cinv-dim" title="'+cinvEsc(t)+'">\u2014</span>';
  }
  var cls = m.pct<0 ? 'cinv-rojo' : (m.pct<15 ? 'cinv-ambar' : 'cinv-verde');
  var d=CINV_MARGEN[x.itemcode]||{};
  var tt='Margen sobre todas las ventas del art\u00edculo'
    +(d.ventas?(': '+cinvMon(d.ventas)+' facturados'):'')
    +(d.unidades?(', '+cinvN(d.unidades)+' unidades'):'')+'.';
  return '<span class="'+cls+'" title="'+cinvEsc(tt)+'">'+m.pct.toFixed(1)+'%</span>';
}

// ── Ultima compra e historico ─────────────────────────────────────────────
function cinvUltCompra(x){
  var e=CINV_LLEG[x.itemcode]||{};
  var c=cinvNum(e.u_cant_ult_ent);
  if(!c) return '<span class="cinv-dim">\u2014</span>';
  var n=String(e.u_nentrada||'').trim();
  return cinvN(c)+(n?(' <span class="cinv-dim">('+cinvEsc(n)+')</span>'):'');
}
function cinvUltCompraNum(x){
  var e=CINV_LLEG[x.itemcode]||{};
  return cinvNum(e.u_cant_ult_ent);
}
function cinvHist(x){
  var e=CINV_LLEG[x.itemcode]||{};
  return cinvNum(e.hist_comprado);
}

// Los chips de estado que el RPC no cubre se aplican aqui.
function cinvFiltroLocal(filas){
  return filas.filter(function(x){
    if(CINV_CHIP==='stock'     && !(cinvNum(x.onhand)>0)) return false;
    if(CINV_CHIP==='reservado' && !(cinvNum(x.iscommited)>0)) return false;
    if(CINV_CHIP==='llegar'    && !(cinvNum(x.onorder)>0)) return false;
    if(CINV_CHIP==='negativo'  && !(cinvDisp(x)<0)) return false;
    if(CINV_MIN.disp!=='' && cinvDisp(x) < +CINV_MIN.disp) return false;
    return true;
  });
}

function cinvOrdenarLocal(filas){
  var d=cinvOrdDef();
  if(!d.local) return filas;
  var campo=d.local, s=d.desc?-1:1;

  // itemcode, itemname y fechaentrada se comparan como texto. La fecha viene
  // como AAAA-MM-DD, que ordenada alfabeticamente ya queda cronologica.
  var TXT={itemcode:1, itemname:1, fechaentrada:1};
  if(TXT[campo]){
    return filas.slice().sort(function(a,b){
      return String(a[campo]||'').localeCompare(String(b[campo]||''),'es',
        {numeric:true, sensitivity:'base'})*s;
    });
  }

  var val=function(x){
    if(campo==='iscommited')   return cinvNum(x.iscommited);
    if(campo==='disponible')   return cinvDisp(x);
    if(campo==='onorder')      return cinvNum(x.onorder);
    if(campo==='bultos')         return cinvBultos(x);
    if(campo==='u_cant_ult_ent') return cinvUltCompraNum(x);
    if(campo==='hist_comprado')  return cinvHist(x);
    if(campo==='margen'){
      var m=cinvMargen(x);
      return m ? m.pct : (d.desc?-1e9:1e9);   // los que no tienen, al final
    }
    if(campo==='prox_llegada'){
      var dd=cinvDias(cinvLlegada(x));
      return dd==null ? (d.desc?-1e9:1e9) : dd;   // los sin fecha, al final
    }
    return 0;
  };
  return filas.slice().sort(function(a,b){ return (val(a)-val(b))*s; });
}

// SCROLL INFINITO
// Antes se escuchaba el scroll de `window`, y no disparaba: el evento no llega
// ahi si quien se desplaza es un contenedor interno. IntersectionObserver
// avisa cuando el pie entra en pantalla sea cual sea el elemento que scrollea,
// y de paso no corre codigo en cada pixel de desplazamiento.
// El listado ocupa lo que quede de pantalla por debajo de los filtros. Se
// calcula en vez de fijarlo con un calc(): la barra de filtros cambia de alto
// segun cuantos departamentos haya y si el panel de Filtros esta abierto.
function cinvAltura(){
  var sc=document.getElementById('cinv-scroll'); if(!sc) return;
  var top=sc.getBoundingClientRect().top;
  var alto=Math.max(340, window.innerHeight - top - 24);
  sc.style.maxHeight=alto+'px';
}
if(typeof window!=='undefined' && !window._cinvResize){
  window._cinvResize=true;
  window.addEventListener('resize', function(){ cinvAltura(); });
}

var CINV_OBS=null;
function cinvObservar(){
  var pie=document.getElementById('cinv-mas'); if(!pie) return;
  if(CINV_OBS){ try{ CINV_OBS.disconnect(); }catch(e){} }
  if(typeof IntersectionObserver!=='function'){
    // Navegador viejo: se vuelve al scroll de siempre, en captura para
    // enterarse tambien de los contenedores internos.
    if(!window._cinvScrollFB){
      window._cinvScrollFB=true;
      // En captura para enterarse tambien del scroll del contenedor interno.
      document.addEventListener('scroll', function(){
        var m=document.getElementById('cinv-mas');
        if(!m || CINV_CARGANDO || CINV_FIN) return;
        var sc=document.getElementById('cinv-scroll');
        var lim=sc ? (sc.getBoundingClientRect().bottom+320) : (window.innerHeight+320);
        if(m.getBoundingClientRect().top < lim) cinvCargarMas();
      }, true);
    }
    return;
  }
  CINV_OBS=new IntersectionObserver(function(ent){
    if(!ent[0] || !ent[0].isIntersecting) return;
    if(CINV_CARGANDO || CINV_FIN) return;
    var pg=document.getElementById('page-cinv');
    if(pg && !pg.classList.contains('active')) return;
    cinvCargarMas();
  }, {root:document.getElementById('cinv-scroll'), rootMargin:'400px 0px'});
  CINV_OBS.observe(pie);
}

async function cinvCargarMas(){
  if(CINV_CARGANDO || CINV_FIN) return;
  CINV_CARGANDO=true;
  var mas=document.getElementById('cinv-mas');
  if(mas) mas.textContent='Cargando\u2026';

  try{
    if(cinvEsLocal()){
      // Orden por una columna que el RPC no sabe ordenar: se trae un bloque
      // grande de una vez, se completa, se ordena aqui y se pinta entero.
      if(CINV_OFF>0){ CINV_FIN=true; CINV_CARGANDO=false; return; }
      var todo=[], off=0, PS=500;
      while(off<CINV_LOCAL_TOPE){
        var b=await cinvBody(PS, off);
        var r=await cinvRpc(b);
        todo=todo.concat(r);
        if(r.length<PS) break;
        off+=PS;
        if(mas) mas.textContent='Ordenando '+todo.length+'\u2026';
      }
      todo=await cinvCompletar(todo);
      await cinvExtras(todo);
      todo=cinvOrdenarLocal(cinvFiltroLocal(todo));
      CINV_ROWS=todo; CINV_OFF=todo.length; CINV_FIN=true;
      var body=document.getElementById('cinv-body');
      if(body) body.innerHTML='';
      cinvPintar(todo);
    } else {
      var filas=await cinvRpc(await cinvBody(CINV_TANDA, CINV_OFF));
      CINV_OFF += filas.length;
      if(filas.length < CINV_TANDA) CINV_FIN=true;
      filas=await cinvCompletar(filas);
      await cinvExtras(filas);
      var vis=cinvFiltroLocal(filas);
      CINV_ROWS=CINV_ROWS.concat(vis);
      cinvPintar(vis);
      // Si los filtros locales dejaron la tanda casi vacia se sigue trayendo
      // sola: si no, el scroll infinito no se dispara y parece que no hay nada.
      if(!CINV_FIN && vis.length<12) setTimeout(cinvCargarMas, 0);
    }
    cinvAvisoOrden();
  }catch(e){
    if(mas) mas.innerHTML='<span style="color:#DC2626">No se pudo cargar: '
      +cinvEsc(e.message||e)+'</span>';
    CINV_FIN=true;
    CINV_CARGANDO=false;
    return;
  }

  var cnt=document.getElementById('cinv-cnt');
  if(cnt) cnt.textContent=CINV_ROWS.length+(CINV_FIN?' art\u00edculos':'+ art\u00edculos');
  if(mas){
    mas.textContent = CINV_ROWS.length
      ? (CINV_FIN?('Fin del listado \u00b7 '+CINV_ROWS.length+' art\u00edculos'):'Baja para cargar m\u00e1s\u2026')
      : (CINV_FIN?'Sin resultados para este filtro':'Buscando\u2026');
  }
  CINV_CARGANDO=false;

  // El observador solo avisa cuando el pie ENTRA en pantalla. Si tras la tanda
  // sigue visible (pantalla alta, o filtros que dejaron pocas filas) no habria
  // un segundo aviso, asi que se comprueba a mano.
  if(!CINV_FIN){
    var pie=document.getElementById('cinv-mas');
    var sc=document.getElementById('cinv-scroll');
    var limite=sc ? (sc.getBoundingClientRect().bottom+200) : (window.innerHeight+200);
    if(pie && pie.getBoundingClientRect().top < limite){
      setTimeout(cinvCargarMas, 60);
    }
  }
}

function cinvAvisoOrden(){
  var box=document.getElementById('cinv-aviso'); if(!box) return;
  var a=[];

  // Si a la tabla `inventario` le falta alguna columna, decirlo: si no, esos
  // campos salen en blanco y no hay forma de saber por que.
  if(CINV_EXTRA_FALTAN.length){
    var nom={u_cant_ult_ent:'\u00daltima compra', u_nentrada:'N\u00famero de entrada',
             hist_comprado:'Hist. comprado', avgprice:'Costo promedio',
             lastpurprc:'\u00daltimo costo'};
    a.push('A la tabla <b>inventario</b> le faltan columnas, as\u00ed que estos campos '
      +'salen vac\u00edos: <b>'+CINV_EXTRA_FALTAN.map(function(c){ return nom[c]||c; }).join(', ')
      +'</b>. Las sincroniza kennedy_live.py (INV_COLS); hay que crearlas en Supabase.');
  }

  if(cinvEsLocal() && CINV_ROWS.length>=CINV_LOCAL_TOPE){
    a.push('Este orden se calcula sobre los primeros '+cinvN(CINV_LOCAL_TOPE)
      +' art\u00edculos. Filtra por departamento o marca para que entre todo.');
  }

  if(CINV_MARGEN_TABLA===false){
    a.push('El margen hist\u00f3rico sale de la tabla <b>margen_items</b> (ventas reales '
      +'de SAP), que no est\u00e1 en esta base. Mientras tanto sale \u2014; el estimado '
      +'con el costo aparece al pasar el mouse.');
  }

  box.innerHTML = a.length
    ? a.map(function(t){
        return '<div class="card" style="margin-bottom:10px;border-left:4px solid #E0A82E;'
          +'font-size:12.5px;color:var(--text2)">'+t+'</div>';
      }).join('')
    : '';
}

// ── Las columnas ──────────────────────────────────────────────────────────
// Una sola definicion para la cabecera y para las filas: asi las dos usan la
// MISMA plantilla de rejilla y todo queda alineado en vertical. Antes cada
// fila era texto que fluia y los valores no coincidian entre lineas.
function cinvCols(){
  var c=[
    {k:'chk',    l:'',                w:'30px'},
    {k:'foto',   l:'Foto',            w:'46px'},
    {k:'sku',    l:'SKU',             w:'128px'},
    {k:'desc',   l:'Descripci\u00f3n',w:'minmax(200px,1.3fr)'},
    {k:'stock',  l:'Existencia',      w:'86px',  n:1, col:'#2563EB'},
    {k:'sep',    l:'Reservado',       w:'86px',  n:1, col:'#DC2626'},
    {k:'disp',   l:'Disponible',      w:'150px', n:1, col:'#15803D'},
    {k:'lleg',   l:'Por llegar',      w:'128px', n:1, col:'#B45309'},
    {k:'bulto',  l:'Bulto',           w:'66px',  n:1},
    {k:'ultc',   l:'\u00dalt. compra',w:'150px', n:1},
    {k:'hist',   l:'Hist. comprado',  w:'104px', n:1, col:'#7C3AED'},
    {k:'entrada',l:'Entrada',         w:'84px'},
    {k:'precio', l:'Precio',          w:'86px',  n:1}
  ];
  if(cinvVerMargen()) c.push({k:'margen', l:'Margen hist.', w:'92px', n:1});
  return c;
}
function cinvPlantilla(){
  return cinvCols().map(function(c){ return c.w; }).join(' ');
}
function cinvAncho(){
  // Suma aproximada para el min-width del contenedor: por debajo de esto se
  // desplaza en horizontal en vez de apretar las columnas hasta que se pisan.
  var t=0;
  cinvCols().forEach(function(c){
    var m=/(\d+)px/.exec(c.w.indexOf('minmax')===0?'200px':c.w);
    t+=m?+m[1]:200;
  });
  return t+cinvCols().length*10+24;
}

function cinvCabecera(){
  var h='<div id="cinv-thead" class="cinv-g cinv-hd" style="grid-template-columns:'
    +cinvPlantilla()+'">';
  cinvCols().forEach(function(c){
    if(c.k==='chk'){
      h+='<div><input type="checkbox" id="cinv-all" onchange="cinvMarcarTodos(this.checked)" '
        +'title="Marcar todo lo cargado"></div>';
      return;
    }
    var par=CINV_COL_ORD[c.k];
    if(!par){ h+='<div'+(c.n?' class="n"':'')+'>'+cinvEsc(c.l)+'</div>'; return; }

    // Flecha en TODAS las ordenables: doble y tenue si no esta en uso, para
    // que se vea que se puede pulsar; la del sentido activo si lo esta.
    var esAsc=(CINV_ORDEN===par[0]), esDesc=(CINV_ORDEN===par[1]);
    var flecha = esDesc ? '<span class="cinv-fa">\u25bc</span>'
               : (esAsc ? '<span class="cinv-fa">\u25b2</span>'
                        : '<span class="cinv-fl">\u21c5</span>');
    var act=(esAsc||esDesc);
    h+='<div'+(c.n?' class="n"':'')+'>'
      +'<span class="cinv-th" onclick="cinvOrdenarCol(\''+c.k+'\')" '
      +'style="'+(act?'color:var(--blue2)':(c.col?('color:'+c.col):''))+'" '
      +'title="Ordenar por '+cinvEsc(c.l)+'">'
      +cinvEsc(c.l)+' '+flecha+'</span></div>';
  });
  h+='</div>';
  return h;
}

// Alterna el sentido de la columna pulsada.
function cinvOrdenarCol(k){
  var par=CINV_COL_ORD[k]; if(!par) return;
  var nuevo;
  if(CINV_ORDEN===par[1])      nuevo=par[0];        // estaba descendente
  else if(CINV_ORDEN===par[0]) nuevo=par[1];        // estaba ascendente
  else nuevo = CINV_COL_TXT[k] ? par[0] : par[1];   // primera vez
  cinvSetOrden(nuevo);
}

// Fila alineada a la misma rejilla que la cabecera.
function cinvPintar(filas){
  var body=document.getElementById('cinv-body'); if(!body) return;
  var tpl=cinvPlantilla(), verM=cinvVerMargen();
  var h='';
  filas.forEach(function(x){
    var sku=String(x.itemcode||''), j=sku.replace(/'/g,"\\'");
    var e=CINV_LLEG[sku]||{};
    var pack=cinvPack(x), disp=cinvDisp(x);
    var res=cinvNum(x.iscommited), lle=cinvNum(x.onorder);
    var marcado=!!CINV_SEL[sku];

    // "15 + 3 pz": el resto suelto importa al reponer.
    var bult=function(n){
      if(pack<=1 || !(n>0)) return '';
      var b=Math.floor(n/pack), r=n%pack;
      return '<div class="cinv-sub">'+cinvN(b)+' bultos'+(r?(' + '+cinvN(r)+' pz'):'')+'</div>';
    };

    h+='<div class="cinv-g cinv-row'+(marcado?' sel':'')+'" data-sku="'+cinvEsc(sku)+'" '
      +'style="grid-template-columns:'+tpl+'">';

    h+='<div><input type="checkbox"'+(marcado?' checked':'')
      +' onchange="cinvMarcar(\''+j+'\',this.checked)"></div>';

    h+='<div>'+(typeof lineFoto==='function'?lineFoto(x.picturname,x.foto_url):'')+'</div>';

    h+='<div><span class="cinv-sku" onclick="cinvVerItem(\''+j+'\')" title="Abrir la ficha">'
      +cinvEsc(sku)+'</span></div>';

    h+='<div style="min-width:0"><div class="cinv-desc" title="'+cinvEsc(x.itemname||'')+'">'
      +cinvEsc(x.itemname||'')+'</div>'
      +(x.marca?('<div class="cinv-sub">'+cinvEsc(x.marca)+'</div>'):'')+'</div>';

    h+='<div class="n"><b>'+cinvN(x.onhand)+'</b></div>';

    h+='<div class="n">'+(res>0
      ? '<b class="cinv-rojo cinv-lnk" onclick="verSeparadoVentas(\''+j+'\')" '
        +'title="Ver qui\u00e9n lo tiene separado">'+cinvN(res)+'</b>'
      : '<span class="cinv-dim">0</span>')+'</div>';

    h+='<div class="n"><b class="'+(disp>0?'cinv-verde':(disp<0?'cinv-rojo':'cinv-dim'))+'">'
      +cinvN(disp)+'</b>'+bult(disp)+'</div>';

    h+='<div class="n">'+(lle>0
      ? '<b class="cinv-ambar cinv-lnk" onclick="cinvVerLlegadas(\''+j+'\')" '
        +'title="Ver en qu\u00e9 orden viene">'+cinvN(lle)+'</b>'
        +(cinvLlegada(x)?('<div class="cinv-sub">'+cinvLlegadaTxt(x)+'</div>'):'')
      : '<span class="cinv-dim">0</span>')+'</div>';

    h+='<div class="n">'+cinvN(pack)+' <span class="cinv-sub">pz</span></div>';

    var uc=cinvNum(e.u_cant_ult_ent);
    h+='<div class="n" title="Cantidad de la \u00faltima compra">'
      +(uc?('<b>'+cinvN(uc)+'</b>'+bult(uc)
            +(e.u_nentrada?('<div class="cinv-sub">('+cinvEsc(e.u_nentrada)+')</div>'):''))
          :'<span class="cinv-dim">\u2014</span>')+'</div>';

    var hc=cinvHist(x);
    h+='<div class="n" title="Total hist\u00f3rico comprado: facturas de compra menos notas '
      +'de cr\u00e9dito, mismo criterio que el Purchase Analysis by Item de SAP.">'
      +(hc?('<b class="cinv-lila">'+cinvN(hc)+'</b>'):'<span class="cinv-dim">\u2014</span>')+'</div>';

    h+='<div class="cinv-sub" style="font-size:11.5px">'+cinvFechaCorta(x.fechaentrada)+'</div>';

    h+='<div class="n"><b>'+cinvMon(x.precioventa)+'</b></div>';

    if(verM) h+='<div class="n">'+cinvMargenTxt(x)+'</div>';

    h+='</div>';
  });
  body.insertAdjacentHTML('beforeend', h);
}


/* ══════════════════════════════════════════════════════════════════════════
   SELECCION Y CARRITO
   ══════════════════════════════════════════════════════════════════════════ */

function cinvMarcar(sku, on){
  var x=CINV_ROWS.filter(function(r){ return r.itemcode===sku; })[0];
  if(on && x) CINV_SEL[sku]=x; else delete CINV_SEL[sku];
  var tr=document.querySelector('.cinv-row[data-sku="'+String(sku).replace(/"/g,'')+'"]');
  if(tr) tr.classList.toggle('sel', !!on);
  cinvPintarSelbar();
}

function cinvMarcarTodos(on){
  CINV_ROWS.forEach(function(x){
    if(on) CINV_SEL[x.itemcode]=x; else delete CINV_SEL[x.itemcode];
  });
  var trs=document.querySelectorAll('.cinv-row');
  for(var i=0;i<trs.length;i++){
    var c=trs[i].querySelector('input[type=checkbox]');
    if(c) c.checked=!!on;
    trs[i].classList.toggle('sel', !!on);
  }
  cinvPintarSelbar();
}

function cinvSelLimpiar(){
  CINV_SEL={};
  var trs=document.querySelectorAll('.cinv-row');
  for(var i=0;i<trs.length;i++){
    var c=trs[i].querySelector('input[type=checkbox]');
    if(c) c.checked=false;
    trs[i].classList.remove('sel');
  }
  var a=document.getElementById('cinv-all'); if(a) a.checked=false;
  cinvPintarSelbar();
}

function cinvPintarSelbar(){
  var bar=document.getElementById('cinv-selbar'); if(!bar) return;
  var codes=Object.keys(CINV_SEL);
  if(!codes.length){ bar.style.display='none'; bar.innerHTML=''; return; }

  var uds=0, monto=0;
  codes.forEach(function(c){
    var x=CINV_SEL[c], p=cinvPack(x);
    uds+=p; monto+=p*cinvNum(x.precioventa);
  });

  bar.style.display='flex';
  bar.innerHTML='<b style="font-size:13px">'+codes.length+' marcado(s)</b>'
    +'<span style="font-size:11.5px;color:var(--text3)">1 bulto c/u \u00b7 '
      +cinvN(uds)+' und \u00b7 '+cinvMon(monto)+'</span>'
    +'<span style="display:flex;align-items:center;gap:6px;margin-left:auto;flex-wrap:wrap">'
      +'<span style="font-size:11.5px;color:var(--text3)">Bultos c/u</span>'
      +'<input id="cinv-nb" class="cinv-mini" type="number" min="1" value="1" style="width:62px">'
      +'<button class="btn btn-sm btn-p" onclick="cinvAlCarrito()">\ud83d\uded2 Agregar al pedido</button>'
      +'<button class="btn btn-sm" onclick="cinvSelLimpiar()">Quitar marcas</button>'
    +'</span>';
}

// Manda lo marcado al carrito de Nuevo pedido (npLineas), el mismo que usa el
// resto del portal. Alli se ajustan cantidades y precios como siempre.
function cinvAlCarrito(){
  var codes=Object.keys(CINV_SEL);
  if(!codes.length) return;
  if(typeof npAgregar!=='function' || typeof npLineas==='undefined'){
    alert('No encuentro el carrito de pedidos. Comprueba que kennedy-2.js est\u00e9 '
      +'cargado antes que esta pantalla.');
    return;
  }

  var nb=parseInt((document.getElementById('cinv-nb')||{}).value,10);
  if(!(nb>0)) nb=1;

  var nuevos=0, sumados=0;
  codes.forEach(function(c){
    var x=CINV_SEL[c];
    var pack=cinvPack(x), cant=pack*nb;
    var ya=npLineas.filter(function(l){ return l.itemcode===c; })[0];
    if(ya){ ya.quantity=cinvNum(ya.quantity)+cant; sumados++; }
    else{
      npAgregar({itemcode:c, itemname:x.itemname||c, quantity:cant,
                 price:cinvNum(x.precioventa), discount:0, whscode:'', bulto:pack, note:''});
      nuevos++;
    }
  });

  try{ if(typeof catUpdateFooter==='function') catUpdateFooter(); }catch(e){}
  try{ if(typeof npUpdateBtn==='function') npUpdateBtn(); }catch(e){}

  cinvSelLimpiar();

  // Se ofrece ir al pedido: si no, no hay forma de saber que llegaron.
  var msg='\u2713 '+nuevos+' art\u00edculo(s) agregado(s)'
    +(sumados?(' y '+sumados+' sumado(s) a lo que ya estaba'):'')
    +'.\nEl pedido lleva '+npLineas.length+' l\u00ednea(s).\n\n\u00bfAbrir Nuevo pedido ahora?';
  if(confirm(msg)){
    try{ go('nuevo_pedido', document.getElementById('nav-np')); }catch(e){}
    try{ if(typeof npIr==='function') npIr(2); }catch(e){}
  }
}


/* ══════════════════════════════════════════════════════════════════════════
   ¿CUANDO LLEGA?
   ══════════════════════════════════════════════════════════════════════════ */

async function cinvVerLlegadas(itemcode){
  if(!itemcode) return;
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:100000;'
    +'display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--card,#fff);border-radius:12px;padding:24px;'
    +'max-width:560px;width:100%"><div style="font-size:13px;color:var(--text3,#888)">'
    +'Buscando en qu\u00e9 orden viene '+cinvEsc(itemcode)+'\u2026</div></div>';
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);

  var lineas=[], ordenes={};
  try{
    lineas = await q('opor_lineas',
      'select=docnum,docentry,itemcode,itemname,cantidad,cantidad_pendiente'
      +'&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=60') || [];
    lineas = lineas.filter(function(l){ return cinvNum(l.cantidad_pendiente)>0; });
    if(lineas.length){
      var docs=lineas.map(function(l){ return l.docentry; }).filter(function(d){ return d!=null; });
      if(docs.length){
        // El nombre del proveedor solo se PIDE si quien mira puede verlo. No
        // basta con ocultarlo al pintar: viajaria al navegador igual y
        // cualquiera lo ve en las herramientas del desarrollador.
        var _verProv = (typeof veProveedor==='function' && veProveedor());
        var o = await q('opor_ordenes',
          'select=docentry,docnum,duedate,eta,'+(_verProv?'vendor_name,':'')
          +'barco,num_contenedor_campo,'
          +'puerto_embarque,pais,estado_compra&docentry=in.('+docs.join(',')+')&limit=60') || [];
        o.forEach(function(x){ ordenes[x.docentry]=x; });
      }
    }
  }catch(e){ lineas=[]; }

  var resumen=null;
  if(!lineas.length){
    try{
      var inv=await q('inventario','select=onorder,prox_llegada,ordenes_abiertas&itemcode=eq.'
        +encodeURIComponent(itemcode)+'&limit=1');
      resumen=(inv&&inv[0])||null;
    }catch(e){}
  }

  var total=lineas.reduce(function(a,l){ return a+cinvNum(l.cantidad_pendiente); },0);

  var h='<div style="background:var(--card,#fff);border-radius:12px;padding:20px;'
    +'max-width:600px;width:100%;max-height:88vh;overflow-y:auto">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px">'
    +'<div><div style="font-size:14px;font-weight:700">Mercanc\u00eda por llegar</div>'
    +'<div style="font-size:11.5px;color:var(--text3,#888);margin-top:2px">'+cinvEsc(itemcode)
    +(lineas.length?(' \u00b7 '+lineas.length+' orden(es) \u00b7 '+cinvN(total)+' und pendientes'):'')
    +'</div></div><button onclick="this.closest(\'div[style*=fixed]\').remove()" '
    +'style="background:none;border:none;font-size:22px;cursor:pointer;color:var(--text3,#888);'
    +'line-height:1">&times;</button></div>';

  if(!lineas.length){
    if(resumen && cinvNum(resumen.onorder)>0){
      h+='<div style="font-size:12.5px;color:var(--text2)">Hay <b>'+cinvN(resumen.onorder)
        +'</b> unidades por llegar'
        +(resumen.ordenes_abiertas?(' en '+cinvN(resumen.ordenes_abiertas)+' orden(es)'):'')
        +(resumen.prox_llegada?(', y la primera llega el <b>'
          +cinvEsc(cinvFechaCorta(resumen.prox_llegada))+'</b>'):'')
        +'.<div style="margin-top:8px;color:var(--text3);font-size:11.5px">El detalle por orden '
        +'(barco, contenedor, puerto) sale de las tablas de compras, que este usuario no tiene '
        +'disponibles.</div></div>';
    } else {
      h+='<div style="font-size:12.5px;color:var(--text3,#888);padding:10px 0">'
        +'No hay \u00f3rdenes de compra abiertas con este art\u00edculo.</div>';
    }
  } else {
    h+='<div style="display:flex;flex-direction:column;gap:8px">';
    lineas.forEach(function(l){
      var o=ordenes[l.docentry]||{};
      var fecha=String(o.eta||o.duedate||'').slice(0,10);
      var d=cinvDias(fecha);
      var col = d==null?'var(--text3)':(d<0?'#B91C1C':(d<=15?'#166534':'#B45309'));
      var cuando = fecha
        ? (cinvFechaCorta(fecha)
           +(d==null?'':(d<0?' \u00b7 vencida':(d===0?' \u00b7 hoy':' \u00b7 en '+d+' d\u00edas'))))
        : 'sin fecha';

      h+='<div style="border:1px solid var(--border,#e5e7eb);border-radius:9px;padding:11px 13px;'
        +'background:var(--surface2,#f9fafb)">'
        +'<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start">'
        +'<div style="flex:1;min-width:0">'
          +'<div style="font-size:12.5px;font-weight:700">Orden de compra #'+cinvEsc(l.docnum||'?')+'</div>'
          +((o.vendor_name && typeof veProveedor==='function' && veProveedor())
            ?('<div style="font-size:11.5px;color:var(--text2)">'+cinvEsc(o.vendor_name)+'</div>'):'')
          +'<div style="font-size:12px;color:'+col+';font-weight:600;margin-top:3px">Llega: '+cinvEsc(cuando)+'</div>'
        +'</div>'
        +'<div style="text-align:right;flex-shrink:0">'
          +'<div style="font-size:16px;font-weight:800;color:#B45309">'+cinvN(l.cantidad_pendiente)+'</div>'
          +'<div style="font-size:9.5px;color:var(--text3,#888)">por recibir</div>'
          +'<div style="font-size:10px;color:var(--text3,#888)">de '+cinvN(l.cantidad)+'</div>'
        +'</div></div>';

      var emb=[];
      if(o.barco)                emb.push(['Barco',o.barco]);
      if(o.num_contenedor_campo) emb.push(['Contenedor',o.num_contenedor_campo]);
      if(o.puerto_embarque)      emb.push(['Puerto',o.puerto_embarque]);
      if(o.pais)                 emb.push(['Origen',o.pais]);
      if(o.estado_compra)        emb.push(['Estado',o.estado_compra]);
      if(emb.length){
        h+='<div style="display:flex;gap:14px;flex-wrap:wrap;margin-top:9px;padding-top:9px;'
          +'border-top:1px solid var(--border,#e5e7eb)">';
        emb.forEach(function(p){
          h+='<div><div style="font-size:9.5px;color:var(--text3,#888);text-transform:uppercase;'
            +'letter-spacing:.04em;font-weight:700">'+cinvEsc(p[0])+'</div>'
            +'<div style="font-size:11.5px">'+cinvEsc(p[1])+'</div></div>';
        });
        h+='</div>';
      }
      h+='</div>';
    });
    h+='</div>';
  }
  h+='</div>';
  ov.innerHTML=h;
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
}


/* ══════════════════════════════════════════════════════════════════════════
   EXCEL
   ══════════════════════════════════════════════════════════════════════════ */

async function cinvExcel(){
  if(typeof xlsxExport!=='function'){ alert('El generador de Excel no est\u00e1 disponible.'); return; }
  var btn=document.getElementById('cinv-xlsx');
  var prev=btn?btn.innerHTML:null;
  if(btn){ btn.disabled=true; btn.innerHTML='Preparando\u2026'; }

  try{
    // Se exporta TODO lo filtrado, no solo lo cargado en pantalla.
    var filas=[], off=0, PS=500;
    while(off<20000){
      var r=await cinvRpc(await cinvBody(PS, off));
      filas=filas.concat(r);
      if(r.length<PS) break;
      off+=PS;
      if(btn) btn.innerHTML='Preparando '+filas.length+'\u2026';
    }
    filas=await cinvCompletar(filas);
    await cinvExtras(filas);
    filas=cinvOrdenarLocal(cinvFiltroLocal(filas));
    if(!filas.length){ alert('No hay nada que exportar con este filtro.'); return; }

    var hayFoto=filas.some(function(x){ return !!(x.picturname||x.foto_url); });
    var columns=[];
    if(hayFoto) columns.push({label:'Foto', key:'foto', width:9});
    columns=columns.concat([
      {label:'SKU',              key:'itemcode',    width:16},
      {label:'Descripci\u00f3n', key:'itemname',    width:44},
      {label:'Marca',            key:'marca',       width:18},
      {label:'Existencia',       key:'onhand',      width:12, numFmt:'#,##0'},
      {label:'Reservado',        key:'iscommited',  width:12, numFmt:'#,##0'},
      {label:'Disponible',       key:'__disp',      width:12, numFmt:'#,##0'},
      {label:'Und x bulto',      key:'__pack',      width:12, numFmt:'#,##0'},
      {label:'Bultos disp.',     key:'__bultos',    width:12, numFmt:'#,##0'},
      {label:'Por llegar',       key:'onorder',     width:12, numFmt:'#,##0'},
      {label:'Llega',            key:'__llega',     width:13},
      {label:'D\u00edas',        key:'__dias',      width:9,  numFmt:'#,##0'},
      {label:'\u00d3rdenes',     key:'__ords',      width:10, numFmt:'#,##0'},
      {label:'\u00dalt. compra cant.', key:'__ultc', width:15, numFmt:'#,##0'},
      {label:'\u00dalt. entrada',      key:'__ulte', width:13},
      {label:'Hist. comprado',   key:'__hist',      width:14, numFmt:'#,##0'},
      {label:'Precio venta',     key:'precioventa', width:13, numFmt:'0.00'}
    ]);
    // Costos y margen solo para quien puede verlos en pantalla.
    if(cinvVerMargen()) columns=columns.concat([
      {label:'Costo hist.',      key:'__costo',     width:12, numFmt:'0.00'},
      {label:'Margen hist. %',   key:'__margen',    width:14, numFmt:'0.0'},
      {label:'Margen es real',   key:'__margenreal',width:13}
    ]);
    columns=columns.concat([
      {label:'C\u00f3digo de barras', key:'codebars', width:18},
      {label:'Entrada',          key:'fechaentrada',width:13}
    ]);

    await xlsxExport({
      filename:'consulta-inventario.xlsx',
      titulo:'KENNEDY CENTER CORP. - CONSULTA DE INVENTARIO',
      subtitulo:cinvFiltrosTexto()+'  -  '+filas.length+' art\u00edculos',
      columns:columns, rows:filas,
      fotoKey:(hayFoto?'foto':null),
      fotoUrlFn:function(x){
        try{ var f=fotoPair(x.picturname, x.foto_url); return f.primary||''; }catch(e){}
        return x.foto_url||'';
      },
      fotoCandsFn:function(x){
        try{
          var f=fotoPair(x.picturname, x.foto_url);
          return [f.primary].concat(String(f.fb||'').split('|')).filter(Boolean);
        }catch(e){}
        return x.foto_url?[x.foto_url]:[];
      },
      onProgress:function(d,t){ if(btn) btn.innerHTML='Fotos '+d+'/'+t+'\u2026'; },
      valueFn:function(x,k){
        if(k==='__disp')   return cinvDisp(x);
        if(k==='__pack')   return cinvPack(x);
        if(k==='__bultos') return cinvBultos(x);
        if(k==='__ords')   return cinvOrdenes(x);
        if(k==='__ultc')   return cinvUltCompraNum(x);
        if(k==='__ulte'){  var e=CINV_LLEG[x.itemcode]||{}; return e.u_nentrada||''; }
        if(k==='__hist')   return cinvHist(x);
        if(k==='__costo'){
          var e2=CINV_LLEG[x.itemcode]||{};
          return cinvNum(e2.avgprice)||cinvNum(x.avgprice)
               ||cinvNum(e2.lastpurprc)||cinvNum(x.lastpurprc)||'';
        }
        if(k==='__margen'){ var m=cinvMargen(x); return m?Number(m.pct.toFixed(2)):''; }
        if(k==='__margenreal'){ var m2=cinvMargen(x); return m2?(m2.real?'S\u00ed':'Estimado'):''; }
        if(k==='__llega')  return cinvFechaCorta(cinvLlegada(x));
        if(k==='__dias'){  var d=cinvDias(cinvLlegada(x)); return d==null?'':d; }
        if(k==='onhand'||k==='iscommited'||k==='onorder') return cinvNum(x[k]);
        if(k==='precioventa') return cinvNum(x.precioventa);
        if(k==='fechaentrada') return String(x.fechaentrada||'').slice(0,10);
        return x[k]==null?'':x[k];
      }
    });
  }catch(e){
    alert('No se pudo generar el Excel: '+(e&&e.message?e.message:e));
  }finally{
    if(btn){ btn.disabled=false; btn.innerHTML=prev; }
  }
}

function cinvFiltrosTexto(){
  var p=[];
  if(CINV_Q) p.push('Busqueda: "'+CINV_Q+'"');
  if(CINV_MARCA) p.push('Marca: '+CINV_MARCA);
  if(CINV_DEPT!=='todos'){
    var d=CINV_DEPTS.filter(function(x){ return x.k===CINV_DEPT; })[0];
    if(d) p.push('Depto: '+d.l);
  }
  var c=CINV_CHIPS.filter(function(x){ return x.k===CINV_CHIP; })[0];
  if(c && CINV_CHIP!=='todos') p.push(c.t);
  if(CINV_MIN.exist!=='')  p.push('Existencia >= '+CINV_MIN.exist);
  if(CINV_MIN.disp!=='')   p.push('Disponible >= '+CINV_MIN.disp);
  if(CINV_MIN.bultos!=='') p.push('Bultos >= '+CINV_MIN.bultos);
  if(CINV_MIN.pmin!=='')   p.push('Precio >= '+CINV_MIN.pmin);
  if(CINV_MIN.pmax!=='')   p.push('Precio <= '+CINV_MIN.pmax);
  return p.join('  \u00b7  ');
}
